import { render, staticRenderFns } from "./orgTree.vue?vue&type=template&id=5947abc4"
import script from "./orgTree.vue?vue&type=script&lang=js"
export * from "./orgTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports